export default __webpack_public_path__ + "static/media/Picture1.8f7804d0.png";